import { InfoCircleTwoTone } from '@ant-design/icons';
import { Tooltip } from 'antd';

export const InfoToolTip: React.FC<{ toolTipText: string; color?: string }> = ({ toolTipText, color = '#FF385C' }) => {
  return (
    <Tooltip placement='topLeft' title={toolTipText} arrow={false}>
      <InfoCircleTwoTone twoToneColor={color} />
    </Tooltip>
  );
};
